module.exports = __webpack_public_path__ + "assets/img/120.e8c56fef.png";